import { ArrowRightAlt } from '@mui/icons-material';
import { Box } from '@mui/material';
import { ReactNode } from 'react';

import { useChangedCellStyles } from './useStyles';

type Props = {
  oldValue: ReactNode;
  newValue: ReactNode;
};

export const BaseChangedCell = (props: Props) => {
  const { oldValue, newValue } = props;
  const cellStyles = useChangedCellStyles();

  return (
    <Box sx={cellStyles.changedCell}>
      <Box sx={cellStyles.oldValue}>{oldValue}</Box>
      <Box sx={cellStyles.newValue}>
        <ArrowRightAlt />
        {newValue}
      </Box>
    </Box>
  );
};
